import script from "./Solutions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Solutions.vue?vue&type=script&setup=true&lang=ts"

import "./Solutions.vue?vue&type=style&index=0&id=0361ee0e&lang=scss"

const __exports__ = script;

export default __exports__